import { APP_ENV } from '@my/config'
import { useAuthedRequestFn } from '../request-fn'
import { initializeApp } from "firebase/app";
import { getAnalytics } from "./analytics";
// Import the functions you need from the SDKs you need
/* 
import { getMessaging, onMessage, getToken } from "firebase/messaging"; */
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC3FFJdak9lD4MzoQ25rnCav2OCVaqksgw",
  authDomain: "twd-tza.firebaseapp.com",
  projectId: "twd-tza",
  storageBucket: "twd-tza.firebasestorage.app",
  messagingSenderId: "104109811987",
  appId: "1:104109811987:web:e783a7cbd9cd5f2d5392e6",
  measurementId: "G-1J7JVMMGS2"
};

// Initialize Firebase
if (APP_ENV.TZA_ENV === 'production') {
  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);
}

const longPollingHandlers = {} as { [pollingKey: string]: Array<() => Promise<any>> };
const RegisterPollingHandler = (pollingKey: string, fn: () => Promise<any>) => {
  if (!longPollingHandlers[pollingKey]) {
    longPollingHandlers[pollingKey] = [];
  }
  longPollingHandlers[pollingKey].push(fn);
}
const TriggerPollingHandlers = async (pollingKey: string) => {
  const handlers = longPollingHandlers[pollingKey] || [];
  const promises = handlers.map((fn) => fn());
  return await Promise.allSettled(promises);
}

export const LongPollingSvc = {
  registerHandler: RegisterPollingHandler,
  trigger: TriggerPollingHandlers
};

const MessageFunctionActionMap = {} as { [messageKey: string]: Array<() => Promise<any>> };
export const RegisterFCMMessageAction = (messageKey: string, fn: () => Promise<any>) => {
  if (!MessageFunctionActionMap[messageKey]) {
    MessageFunctionActionMap[messageKey] = [];
  }
  MessageFunctionActionMap[messageKey].push(fn);
}

/* 
// Initialize Firebase Cloud Messaging and get a reference to the service
const messaging = getMessaging(app);
// Add the public key generated from the console here.
getToken(messaging, {vapidKey: APP_ENV.FCM_VAPID}).then((currentToken) => {
  if (currentToken) {
    // Send the token to your server and update the UI if necessary
    // ...
  } else {
    // Show permission request UI
    console.log('No registration token available. Request permission to generate one.');
    // ...
  }
}).catch((err) => {
  console.log('An error occurred while retrieving token. ', err);
  // ...
});

onMessage(messaging, (payload) => {
  console.log('Message received. ', payload);
  // ...
  const actionFns = MessageFunctionActionMap[payload?.data?.messageKey || ''] || [];

  const proFn = async () => {
    await Promise.allSettled(actionFns.map(fn => fn()));
  };

  proFn();
}); */


